<template>
  <n-message-provider>
    <n-dialog-provider>
      <router-view></router-view>
    </n-dialog-provider>
  </n-message-provider>
</template>

<script>
import { NMessageProvider, NDialogProvider } from 'naive-ui'
import permissionChecker from '@/utils/permission'

export default {
  name: 'AppMain',
  components: {
    NMessageProvider,
    NDialogProvider
  },
  async created() {
    // 应用启动时初始化权限
    if (localStorage.getItem('admin_token')) {
      try {
        await permissionChecker.init()
      } catch (error) {
        console.error('初始化权限失败:', error)
      }
    }
  }
}
</script>

<style>
/**
 * 简洁现代化设计系统
 * 设计原则：清晰、简约、高效
 */

/* 基础重置 */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

/* 主题色彩变量 */
:root {
  /* 主色调 - 经典 Emerald 绿 */
  --primary-color: #10b981;
  --primary-hover: #059669;
  --primary-pressed: #047857;
  --primary-light: #ecfdf5;
  --primary-gradient: linear-gradient(135deg, #10b981 0%, #059669 100%);
  
  /* 中性色 - 更加平衡的灰阶 */
  --text-primary: #111827;
  --text-secondary: #4b5563;
  --text-tertiary: #9ca3af;
  --text-disabled: #d1d5db;
  
  /* 背景色 */
  --bg-body: #f3f4f6;
  --bg-card: #ffffff;
  --bg-hover: #f9fafb;
  --bg-active: #f3f4f6;
  
  /* 边框 */
  --border-color: #e5e7eb;
  --border-hover: #d1d5db;
  
  /* 状态色 */
  --success-color: #10b981;
  --warning-color: #f59e0b;
  --error-color: #ef4444;
  --info-color: #3b82f6;
  
  /* 阴影 - 更柔和多层级 */
  --shadow-xs: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  --shadow-sm: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  --shadow-xl: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  
  /* 圆角 */
  --radius-sm: 0.375rem;
  --radius-md: 0.5rem;
  --radius-lg: 0.75rem;
  --radius-xl: 1rem;

  /* 动画 */
  --transition-base: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

body {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  font-size: 14px;
  line-height: 1.6;
  color: var(--text-primary);
  background: var(--bg-body);
  min-height: 100vh;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#app {
  min-height: 100vh;
}

/* 滚动条美化 */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background: #d1d5db;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: #9ca3af;
}

/* 简化的动画 */
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.fade-in {
  animation: fadeIn 0.3s ease-in-out;
}
</style>
